import {
  FITCH_RATINGS,
  JCR_RATINGS,
  MOODYS_RATINGS,
  SP_RATINGS,
  ALLIANZ_RATINGS,
  CREDIT_CLASSIFICATIONS,
  type RatingScale,
  type ComboboxOption
} from '@klear/constants'

export const RATING_SCALE_OPTIONS: ComboboxOption<RatingScale>[] = [
  { value: 'IG', label: 'Investment Grade (IG)' },
  { value: 'Allianz', label: 'Allianz (Insured)' }
]

export const CREDIT_CLASSIFICATION_OPTIONS: ComboboxOption<(typeof CREDIT_CLASSIFICATIONS)[number]>[] = [
  { value: 'IG', label: 'Investment Grade (IG)' },
  { value: 'Insured', label: 'Insured (Allianz)' }
]

export const SP_RATING_OPTIONS: ComboboxOption<(typeof SP_RATINGS)[number]>[] = SP_RATINGS.map((rating) => ({
  value: rating,
  label: rating
}))

export const MOODYS_RATING_OPTIONS: ComboboxOption<(typeof MOODYS_RATINGS)[number]>[] = MOODYS_RATINGS.map(
  (rating) => ({
    value: rating,
    label: rating
  })
)

export const FITCH_RATING_OPTIONS: ComboboxOption<(typeof FITCH_RATINGS)[number]>[] = FITCH_RATINGS.map((rating) => ({
  value: rating,
  label: rating
}))

export const JCR_RATING_OPTIONS: ComboboxOption<(typeof JCR_RATINGS)[number]>[] = JCR_RATINGS.map((rating) => ({
  value: rating,
  label: rating
}))

export const ALLIANZ_RATING_OPTIONS: ComboboxOption<(typeof ALLIANZ_RATINGS)[number]>[] = ALLIANZ_RATINGS.map(
  (rating) => ({
    value: rating,
    label: rating
  })
)

export const RATING_OPTIONS: Record<RatingScale, ComboboxOption<string>[]> = {
  IG: SP_RATING_OPTIONS as ComboboxOption<string>[],
  Allianz: ALLIANZ_RATING_OPTIONS as ComboboxOption<string>[]
}
